import React from 'react';
import {useMemo} from 'react';
import {VisualizationSpec} from 'react-vega';
import CustomPanelRenderer from '../Vega3/CustomPanelRenderer';
import * as Panel2 from './panel';
import * as CGReact from './cg/cgreact';

const inputType = {
  type: 'array' as const,
  objectType: {
    type: 'dict' as const,
    objectType: {
      type: 'union' as const,
      members: [null, 'string' as const],
    },
  },
};

type PanelMultiStringHistogramProps = Panel2.PanelProps<typeof inputType>;

/* eslint-disable no-template-curly-in-string */

const HISTO_SPEC: VisualizationSpec = {
  $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
  description: 'A simple histogram',
  data: {
    name: 'wandb',
  },
  transform: [
    {
      aggregate: [
        {
          op: 'count',
          as: 'value_count',
        },
      ],
      groupby: ['name', 'value'],
    },
    {
      window: [{op: 'row_number', as: 'value_rank'}],
      sort: [
        {
          field: 'value_count',
          order: 'descending',
        },
      ],
    },
    {filter: `datum.value_rank < 100`},
  ],
  title: '${string:title}',
  mark: {type: 'bar', tooltip: {content: 'data'}},
  encoding: {
    y: {
      type: 'nominal',
      field: 'value',
      axis: {
        title: null,
      },
    },
    color: {
      field: 'name',
      title: null,
    },
    x: {
      field: 'value_count',
      stack: null,
      type: 'quantitative',
    },
    opacity: {value: 0.7},
    order: {
      field: 'name',
    },
  },
};

const PanelMultiStringHistogram: React.FC<PanelMultiStringHistogramProps> = props => {
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);
  const data = useMemo(() => {
    const nodeValue = nodeValueQuery.result;
    if (nodeValueQuery.loading || nodeValue.length === 0) {
      return [];
    }
    const keys = Object.keys(nodeValue[0]);
    const result: Array<{name: string; value: number}> = [];
    for (const row of nodeValue) {
      for (const key of keys) {
        result.push({name: key, value: (row as any)[key]});
      }
    }
    return result;
  }, [nodeValueQuery.loading, nodeValueQuery.result]);
  return (
    <div style={{width: 400, maxHeight: 200, overflowY: 'auto'}}>
      <CustomPanelRenderer
        spec={HISTO_SPEC}
        loading={props.loading}
        slow={false}
        data={data}
        userSettings={{fieldSettings: {}, stringSettings: {title: ''}}}
      />
    </div>
  );
};

export const Spec: Panel2.PanelSpec = {
  id: 'multi-string-histogram',
  Component: PanelMultiStringHistogram,
  inputType,
};
